import Banner from 'components/tailgrids-ui/banner';
import React from 'react';

function BannerTastic({ data }) {
  return <Banner {...data} />;
}

export default BannerTastic;
